//Importaciones
import i18next from 'i18next';
import React from 'react'
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';

function ELEMENT_CONTRACT_PORTFOLIO_SUMMARY(props) {
    //Helpers
    const { t } = useTranslation();

    const { 
      inputParam_HideHeader = false,
      inputParam_ComponentContent = null,
      inputParam_UseFake = false,
      inputParam_BoardStructure = null,
      inputParam_Container = null
    } = props;

    const state = {
      style_value_parent: {backgroundColor: "#efefef"},
      style_value: {fontSize: "22px"},
      style_value_short: {fontSize: "18px"},
      style_text: {fontSize: "14px", backgroundColor: "#efefef"}
    }

    const fakeComponentContent = [
      { total: '--', name: 'CLP' },
      { total: '--', name: 'USD' },
      { total: '--', name: 'UF' }
    ];

    const renderContent = () => {
      return  <Row
                className='px-3 mx-0 w-100'
                style={{
                  opacity: inputParam_UseFake ? ".4" : ""
                }}
              >
                {
                  !inputParam_UseFake && inputParam_ComponentContent?.item?.l_currency.map((item, index) => (
                    <Col xl={6} key={index} className='px-0'>
                      <Row className='border m-1'>
                        <Col>
                          <Row style={state.style_value_parent}><Col style={state.style_value}>{Math.round(item.total).toLocaleString(i18next.language)}</Col></Row>
                          <Row className='border-top' style={state.style_text}>
                            <Col>{t('data-lang-lbl-portfolioamount')}</Col>
                            <Col className='col-auto me-auto'>{item.name}</Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  ))
                }
                {
                  inputParam_UseFake && fakeComponentContent.map((item, index) => (
                    <Col xl={6} key={index} className='px-0'>
                      <Row className='border m-1'>
                        <Col>
                          <Row style={state.style_value_parent}><Col style={state.style_value}>{Math.round(item.total).toLocaleString(i18next.language)}</Col></Row>
                          <Row className='border-top' style={state.style_text}>
                            <Col>{t('data-lang-lbl-portfolioamount')}</Col>
                            <Col className='col-auto me-auto'>{item.name}</Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  ))
                }
                <Col xl={6} className={'px-0'}>
                  <Row className='border m-1'>
                    <Col>
                      <Row style={state.style_value_parent}><Col style={state.style_value}>{!inputParam_UseFake ? inputParam_ComponentContent?.item?.endowment : '--'}</Col></Row>
                      <Row className='border-top' style={state.style_text}><Col>{t('data-lang-lbl-endowmentportfolio')}</Col></Row>
                    </Col>
                  </Row>
                </Col>
                <Col xl={6} className={'px-0'}>
                  <Row className='border m-1'>
                    <Col>
                      <Row style={state.style_value_parent}><Col className='d-flex'><div style={state.style_value}>{!inputParam_UseFake ? inputParam_ComponentContent?.item?.vigentes : '--'}/</div><div className='pt-1' style={state.style_value_short}>{!inputParam_UseFake ? inputParam_ComponentContent?.item?.vigentes + inputParam_ComponentContent?.item?.vencidos : '--'}</div></Col></Row>
                      <Row className='border-top' style={state.style_text}><Col>{t('data-lang-lbl-availableportfoliocontracts')}</Col></Row>
                    </Col>
                  </Row>
                </Col>
                <Col xl={6} className={'px-0'}>
                  <Row className='border m-1'>
                    <Col>
                      <Row style={state.style_value_parent}><Col className='d-flex'><div style={state.style_value}>{!inputParam_UseFake ? inputParam_ComponentContent?.item?.vencidos : '--'}/</div><div className='pt-1' style={state.style_value_short}>{!inputParam_UseFake ? inputParam_ComponentContent?.item?.vigentes : '--'}</div></Col></Row>
                      <Row className='border-top' style={state.style_text}><Col>{t('data-lang-lbl-expiredcurrentcontracts')}</Col></Row>
                    </Col>
                  </Row>
                </Col>
                <Col xl={6} className={'px-0'}>
                  <Row className='border m-1'>
                    <Col>
                      <Row style={state.style_value_parent}><Col style={state.style_value}>{!inputParam_UseFake ? inputParam_ComponentContent?.item?.area : '--'}</Col></Row>
                      <Row className='border-top' style={state.style_text}><Col>{t('data-lang-lbl-contractareas')}</Col></Row>
                    </Col>
                  </Row>
                </Col>
                <Col xl={6} className={'px-0'}>
                  <Row className='border m-1'>
                    <Col>
                      <Row style={state.style_value_parent}><Col style={state.style_value}>{!inputParam_UseFake ? inputParam_ComponentContent?.item?.eecc : '--'}</Col></Row>
                      <Row className='border-top' style={state.style_text}><Col>{t('data-lang-lbl-contracteecc')}</Col></Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
    }

    //Render de componente.
    return (
      <>
        {
          !inputParam_UseFake &&
          <Card className='h-100 d-flex flex-column'>
            {
              !inputParam_HideHeader &&
              <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                  <b>
                    {
                      (!inputParam_UseFake && inputParam_ComponentContent !== null)
                        ? (inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-element_kpi_fte_tree'))
                        : t('data-lang-boxname-element_kpi_fte_tree')
                    }
                  </b>

                  <div className='toolbar d-flex'>
                    <HEADER_TOOLBAR
                      inputParam_BoardStructure={inputParam_BoardStructure}
                      inputParam_Container={inputParam_Container}
                    />
                  </div>
                </Card.Title>
              </Card.Header>
            }

            <Card.Body
              className='p-0 m-0'
              style={{
                flex: "1 1 auto",
                minHeight: 0,
                minWidth: 0,
                overflowY: "auto",
                overflowX: "hidden"
              }}
            >
              { renderContent() }
            </Card.Body>
          </Card>
        }
        { inputParam_UseFake && renderContent() }
      </>

    );
}

ELEMENT_CONTRACT_PORTFOLIO_SUMMARY.propTypes = {
  inputParam_HideHeader: PropTypes.bool.isRequired,
  inputParam_ComponentContent: PropTypes.object.isRequired,
};

export default ELEMENT_CONTRACT_PORTFOLIO_SUMMARY;